module.exports = __webpack_public_path__ + "static/media/35.b36d34a1.mp3";